import { S3Instance } from "@/instance/axios";
import { createMutationKeys, createQueryKeys } from "@lukemorales/query-key-factory";
import {
  S3ApiS3CopyPostRequest,
  S3ApiS3CreateFolderPostRequest,
  S3ApiS3DeleteDeleteRequest,
  S3ApiS3ListGetRequest,
  S3ApiS3MovePostRequest,
  S3ApiS3PresignedGetRequest,
  S3ApiS3RenamePostRequest,
} from "@sizlcorp/sizl-api-document/dist/models";
import { AxiosRequestConfig } from "axios";

export const documents = createQueryKeys("documents", {
  all: null,
  get: (params: S3ApiS3ListGetRequest, option?: AxiosRequestConfig) => {
    return {
      queryKey: [params],
      queryFn: () => S3Instance.s3ListGet(params, option),
    };
  },
  presigned: (params: S3ApiS3PresignedGetRequest) => {
    return {
      queryKey: [params],
      queryFn: () => S3Instance.s3PresignedGet(params),
    };
  },
});

export const mutateDocuments = createMutationKeys("documents", {
  createFolder: (params: S3ApiS3CreateFolderPostRequest) => ({
    mutationKey: [params.s3CreateFolderPostRequest],
    mutationFn: () => S3Instance.s3CreateFolderPost(params),
  }),
  move: (params: S3ApiS3MovePostRequest) => ({
    mutationKey: [params.s3MovePostRequest],
    mutationFn: () => S3Instance.s3MovePost(params),
  }),
  copy: (params: S3ApiS3CopyPostRequest) => ({
    mutationKey: [params.s3MovePostRequest],
    mutationFn: () => S3Instance.s3CopyPost(params),
  }),
  delete: (params: S3ApiS3DeleteDeleteRequest) => ({
    mutationKey: [params.s3DeleteDeleteRequest],
    mutationFn: () => S3Instance.s3DeleteDelete(params),
  }),
  rename: (params: S3ApiS3RenamePostRequest) => ({
    mutationKey: [params.s3RenamePostRequest],
    mutationFn: () => S3Instance.s3RenamePost(params),
  }),
});
